module.exports = __webpack_public_path__ + "img/proimg1.596bb052.jpg";